import { useDispatch } from "react-redux";
import {
    updateCustomModal,
    updateCustomModalTitle,
    updateProductModalType,
    updateAsinId,
} from "@features/modalSlice";
import { ICellRendererParams } from "ag-grid-community";
import { ProductModalType } from "@ts/common-types";
import usePermissionCheck from "@/hooks/usePermissionCheck";

interface IProductAnchorCellRenderer extends ICellRendererParams {
    pinnedColumnValue: string;
}

const ProductAnchorCellRenderer: React.FC<IProductAnchorCellRenderer> = (
    params
) => {
    const dispatch = useDispatch();

    const modalClickHandler = () => {
        dispatch(updateCustomModal(true));
        dispatch(updateCustomModalTitle(params.value));
        dispatch(updateProductModalType(ProductModalType.PRODUCTS_MODAL));
        dispatch(updateAsinId(params.data.asin));
    };

    const { canListKeywords } = usePermissionCheck();

    return (
        <>
            {params.node.rowPinned ? (
                params.pinnedColumnValue
            ) : (
                <>
                    {params.data.asin ? (
                        <div className={`${canListKeywords ? "anchor-class" : ""}`}
                            onClick={canListKeywords ? modalClickHandler : null}
                        >
                            {params.value || ""}
                        </div>
                    ) : (
                        <span>{params.value || ""}</span>
                    )}
                </>
            )
            }
        </>
    );
};

export default ProductAnchorCellRenderer;
